import React from 'react';
import { Info } from 'lucide-react';

const MAX_PEOPLE_PER_DATE = 4;

const Guidelines = () => (
  <div className="border-start border-4 border-warning bg-light p-3 mt-2 rounded-end">
    <div className="d-flex align-items-center mb-2">
      <Info className="text-warning me-2" size={20} />
      <h5 className="fw-semibold text-dark mb-0">Guideline</h5>
    </div>
    <ul className="small text-dark mb-2 ps-3">
      <li>Food distribution will take place in the interior regions of Attapur, within a 10 km radius.</li>
      <li>Our van will be available for food distribution.</li>
      <li>A maximum of {MAX_PEOPLE_PER_DATE} people can book per day, with a limit of 4 members per family.</li>
      <li>Kindly arrive by 11:00 AM. You may first take darshan of the Lordships, honour prasadam, and then proceed for the food distribution service.</li>


      <li>You can cancel and reschedule anytime.</li>

    </ul>
  </div>
);

export default Guidelines;
